export function getSurveysByType(type, surveys) {
  if (type === 'u') {
    return surveys.filter(r => r >= -52 && r <= -48);
  } else if (type === 'n') {
    return surveys.filter(r => r < -52 || r > -48);
  }
  return surveys;
}
